import React from 'react';
import { Tooltip } from 'antd';
import { MaskRestrictedText } from '_src/components';
import holidayIcon from '_src/assets/images/palm-tree.png';

export default [
  {
    title: 'Student',
    dataIndex: 'studentName',
    render: (studentName, { isPublicHoliday, locationType, classSubmittedToFmsca }) => {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ cursor: 'pointer', textDecoration: 'underline' }}>{studentName}</div>
          {isPublicHoliday && locationType === 1 && !classSubmittedToFmsca && (
            <Tooltip title="This student was moved to yard for a Holiday and must still complete theory.">
              <img src={holidayIcon} style={{ height: 19, width: 19 }} />
            </Tooltip>
          )}
        </div>
      );
    }
  },
  {
    title: 'Sponsor',
    dataIndex: 'sponsor',
    render: _ => <MaskRestrictedText text={_} />
  },
  {
    title: 'Location',
    dataIndex: 'branchName'
  }
];
